export function gtag(...args: [string, ...any]) {
  if (typeof window !== 'undefined') {
    if (window.gtag) {
      window.gtag(...args);
    }
  }
}
